export const MAX_DISALLOWED_BIRTH_YEAR = 1897;
